import { ErrorLogger } from './ErrorLogger'

export const loggerService = new ErrorLogger()
